(ns ui.components.icon-button.view
  "The IconButton of ZapKit: a button with only an icon. The classes come from the
   generated `ui.components.icon-button.zapkit-styles`."
  (:require
   [ui.components.icon-button.zapkit-styles :as styles]
   [ui.components.zapkit-variants :as variants]
   [ui.util :as uu]))

(defn button-class
  "Return the classes of the button. `variant` is `:default` (the default) or an
   alert variant of the styles. `compact?` gives the small button of the Card.
   `shrink?` stops the button from shrinking in a flex row. `class` is added last."
  [{:keys [variant compact? shrink? class]}]
  (uu/cm (variants/slot-class (:root styles/icon-button)
                              {:variant (or variant :default)
                               :compact (boolean compact?)
                               :shrink  (boolean shrink?)})
         class))

(defn icon-class
  "Return the classes of the icon inside the button. `size` is `:md` (the
   default, 16 px) or `:sm` (12 px)."
  [size]
  (get-in styles/icon-button [:icon :size (or size :md)]))

(defn view
  "Render an IconButton.

   `:aria-label` names the button for a screen reader. It is required.
   `:variant`, `:compact?`, `:shrink?` and `:class` are the props of `button-class`.
   `:on-click` is called when the user clicks.
   `:disabled?` disables the button.
   `:tag` is `:button` (the default) or `:span`. A `:span` draws the look of the button on
   an element with no button semantics, for the child of a trigger that draws the button
   itself, such as the trigger of a Radix menu. It has no `type` and no `disabled`.
   Other props go to the element, for example `:title` and the props that a
   tooltip trigger gives.

   `icon` is the icon element. Give it the classes of `icon-class`."
  [{:keys [tag] :as props} icon]
  (let [attrs (dissoc props :tag :variant :compact? :shrink? :class :disabled?)]
    (if (= :span tag)
      [:span
       (assoc attrs :class (button-class props))
       icon]
      [:button
       (merge attrs
              {:type     "button"
               :class    (button-class props)
               :disabled (boolean (:disabled? props))})
       icon])))
